import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import uuid from 'react-uuid';

import { useForm } from 'react-hook-form';

import { MdArrowBack } from 'react-icons/md';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import LinearProgress from '@mui/material/LinearProgress';

import AdminDetails from './components/AdminDetails';
import SuperAdminDetails from './components/SuperAdminDetails';

import FileCard from '../FormTickets/components/FileCard';
import ToasterBox from '../../../../components/singleComponents/toaster/ToasterBox';

import { formatDateTime } from '../utils/feedback';

import {
  RootStyled,
  HeaderModalStyled,
  HeaderTitleStyled,
  FeedbackContainer,
  FormTitle,
  MessageContainer,
  MessageTitle,
  MessageTime,
  FieldContainer,
} from './index.styles';

import api, { authHeader } from '../../../../../services/API/apiConfig';

import AttachmentCard from './components/AttachmentCard';
import ClosedWarning from './components/ClosedWarning';
import FilesDropzone from '../FormTickets/components/FilesDropzone';
import ResponseButtons from './components/ResponseButtons';
import TicketReplyBox from './components/TicketReplyBox';

export function SupportTicket() {
  const navigate = useNavigate();
  const { id: ticketId } = useParams();
  const { id: userId } = JSON.parse(localStorage.getItem('user'));

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(true);
  const [feedback, setFeedback] = useState(null);
  const [responding, setResponding] = useState(false);
  const [files, setFiles] = useState([]);
  const [toaster, setToaster] = useState({ open: false, msg: '' });

  console.log(files);

  const markAsRead = async () => {
    const key = [1, 164].includes(userId) ? 'read_by_admin' : 'read_by_user';

    api.patch(
      `/feedbacks/${ticketId}`,
      { [key]: true },
      { headers: authHeader() }
    );
  };

  const getFeedbacks = async () => {
    try {
      const { data } = await api.get(`/feedbacks/${ticketId}`, {
        headers: authHeader(),
      });

      if (data.data.status !== 'closed') {
        markAsRead();
      }

      setFeedback(data.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getFeedbacks();
  }, []);

  return (
    <RootStyled>
      {toaster.open && <ToasterBox message={toaster.msg} showSeconds={5} />}
      {loading ? (
        <LinearProgress sx={{ width: '80%', margin: '40vh auto' }} />
      ) : (
        <>
          <HeaderModalStyled>
            <Button
              style={{ background: 'none', marginLeft: -18 }}
              onClick={() => navigate('/support')}
            >
              <MdArrowBack size={25} />
            </Button>
            <HeaderTitleStyled variant="h1">{`Ticket #${ticketId}`}</HeaderTitleStyled>
          </HeaderModalStyled>

          {[1, 164].includes(userId) && (
            <SuperAdminDetails feedback={feedback} />
          )}

          <FeedbackContainer>
            {![1, 164].includes(userId) && (
              <AdminDetails
                status={feedback.status}
                name={feedback.user.name}
                type={feedback.feedback_type}
                priority={feedback.priority}
                createdAt={feedback.created_at}
              />
            )}

            <FormTitle variant="h3">Mensagem enviada no ticket</FormTitle>
            <MessageContainer>
              <MessageTitle>Assunto</MessageTitle>
              <Typography>{feedback.subject}</Typography>
            </MessageContainer>
            <MessageContainer
              sx={{
                borderRadius:
                  !responding && !feedback.messages.length ? '0 0 8px 8px' : 0,
                borderBottom:
                  responding || feedback.messages.length
                    ? 'none'
                    : '1px solid #B0B0B0',
              }}
            >
              <Box sx={{ minWidth: '15%' }}>
                <MessageTitle>{feedback.user.name}</MessageTitle>
                <MessageTime>{formatDateTime(feedback.created_at)}</MessageTime>
              </Box>
              <Box sx={{ width: '100%' }}>
                <Typography>{feedback.description}</Typography>
                {!!feedback.attachments.length &&
                  feedback.attachments.map(({ id, file }) => (
                    <AttachmentCard key={id} file={file} />
                  ))}
              </Box>
            </MessageContainer>
            {feedback.messages.map(
              (
                {
                  id,
                  raw_content: rawContent,
                  updated_at: updatedAt,
                  attachments,
                },
                index,
                array
              ) => (
                <MessageContainer
                  key={id}
                  sx={{
                    borderRadius:
                      index === array.length - 1 ? '0 0 8px 8px' : 0,
                    borderBottom: index !== array.length - 1 && 'none',
                  }}
                >
                  <Box sx={{ minWidth: '15%' }}>
                    <MessageTitle>
                      {index % 2 === 0 ? 'Suporte SIOON' : feedback.user.name}
                    </MessageTitle>
                    <MessageTime>{formatDateTime(updatedAt)}</MessageTime>
                  </Box>
                  <Box sx={{ width: '100%' }}>
                    <Typography>{rawContent}</Typography>
                    {!!attachments.length &&
                      attachments.map(({ id: attachmentId, file }) => (
                        <AttachmentCard key={attachmentId} file={file} />
                      ))}
                  </Box>
                </MessageContainer>
              )
            )}
            {responding && (
              <MessageContainer sx={{ borderRadius: '0 0 8px 8px' }}>
                <MessageTitle>Resposta</MessageTitle>
                <Box sx={{ width: '90%' }}>
                  <TextField
                    fullWidth
                    multiline
                    rows={5}
                    variant="outlined"
                    placeholder="Digite sua resposta..."
                    {...register('response', { required: 'Campo obrigatório' })}
                    error={!!errors.response}
                    helperText={errors.response && errors.response.message}
                  />

                  <FormTitle variant="h3" sx={{ mt: 4 }}>
                    Anexar arquivos (opcional)
                  </FormTitle>
                  <FieldContainer sx={{ width: '100%' }}>
                    <FilesDropzone
                      setFiles={setFiles}
                      setToaster={setToaster}
                    />
                  </FieldContainer>

                  {files.map(({ name, size }) => (
                    <FileCard
                      key={uuid()}
                      name={name}
                      size={size}
                      setFiles={setFiles}
                      files={files}
                    />
                  ))}
                </Box>
              </MessageContainer>
            )}

            {![1, 164].includes(userId) && feedback?.status === 'closed' && (
              <ClosedWarning lastUpdate={feedback.updated_at} />
            )}

            {![1, 164].includes(userId) &&
              feedback.status === 'answered' &&
              feedback.messages.length % 2 !== 0 && (
                <TicketReplyBox
                  setToaster={setToaster}
                  files={files}
                  setFiles={setFiles}
                />
              )}

            {[1, 164].includes(userId) &&
              feedback.messages.length % 2 === 0 &&
              feedback?.status !== 'closed' && (
                <ResponseButtons
                  responding={responding}
                  setResponding={setResponding}
                  handleSubmit={handleSubmit}
                  files={files}
                />
              )}
          </FeedbackContainer>
        </>
      )}
    </RootStyled>
  );
}
